import '../plugins/LavaLampPlugin.js';
import '../plugins/ResponsiveHelper.js';

// LavaLamp init
export default function initLavaLamp() {
	jQuery('.header-holder > .secondary-nav > ul').lavaLamp({
		items: ' > li',
		activeClass: 'active',
		activeLampClass: 'lava-active',
	});
}
